import moonLocales from '@dazn/moon-locales/localizedLocales.json';

import { chapterNames } from '../configuration/constants';

const getBrowserLanguage = () =>
    (navigator &&
        (navigator.language || '').split('-')[0].toLocaleLowerCase()) ||
    'en';

export const getBannerLanguage = ({
    chapterName,
    startupCountry,
    chapterLanguage,
}: {
    chapterName: string;
    startupCountry?: string;
    chapterLanguage: string;
}) => {
    const browserLanguage = getBrowserLanguage();
    const isLandingpage = chapterName === chapterNames.LANDING_PAGE;
    const isValidLocaleCombination = moonLocales.includes(
        `${browserLanguage}-${(startupCountry || 'EN').toUpperCase()}`,
    );
    const shouldUseBrowserLanguage = isLandingpage && isValidLocaleCombination;

    return shouldUseBrowserLanguage
        ? browserLanguage
        : chapterLanguage.toLowerCase();
};
